import {
  NewsArticlesIndexType,
  NewsArticleDetailType,
  NewsArticleCategory,
  ValueOfOption,
  Paginated,
  NewsArticleListItemType,
  MaybePaginated,
} from '../types/index';
import {axiosClient} from '../axios';
import {
  convertFiltersToSearchString,
  getPaginatedFiltersMapping,
  getViewKeyHeader,
  PaginateableFilters,
  UnpaginatedFilters,
} from '../utils/index';

interface GetNewsArticlesIndexFilters extends PaginateableFilters {
  page?: number;
  category?: ValueOfOption<typeof NewsArticleCategory>;
  year?: string;
}

const newsArticleFiltersMapping = getPaginatedFiltersMapping({
  category: 'category',
  year: 'year',
});

export function getNewsArticlesIndex(
  filters?: UnpaginatedFilters<GetNewsArticlesIndexFilters>,
  viewKey?: string,
): Promise<NewsArticlesIndexType>;
export function getNewsArticlesIndex(
  filters?: GetNewsArticlesIndexFilters,
  viewKey?: string,
): Promise<NewsArticlesIndexType<Paginated<NewsArticleListItemType>>>;
export async function getNewsArticlesIndex(
  filters?: GetNewsArticlesIndexFilters,
  viewKey?: string,
): Promise<NewsArticlesIndexType<MaybePaginated<NewsArticleListItemType>>> {
  const {data} = await axiosClient.get<NewsArticlesIndexType>(
    `/news-articles/${convertFiltersToSearchString(
      filters,
      newsArticleFiltersMapping,
    )}`,
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
}

export const getNewsArticleBySlug = async (
  slug: string,
  viewKey?: string,
): Promise<NewsArticleDetailType> => {
  const {data} = await axiosClient.get<NewsArticleDetailType>(
    `/news-articles/${slug}/`,
    {headers: getViewKeyHeader(viewKey)},
  );
  return data;
};
